import Vue from 'vue'
import Utils from './Utils'
import Auth from './Auth'
export default {
  url: Auth.getUrl('template'),
  paginate (meta) {
    return Utils.paginate(this.url, meta)
  },
  get (id) {
    return Vue.http.get(this.url + '/' + id)
  },
  names () {
    return Vue.http.get(this.url + '/names')
  },
  create (data) {
    return Vue.http.post(this.url, data)
  },
  update (data) {
    return Vue.http.put(this.url + '/' + data.id, data)
  },
  remove (id) {
    return Vue.http.delete(this.url + '/' + id)
  },
  getBaseItem () {
    return {
      id: null,
      name: '',
      template_type: 'html',
      // code: '',
      body: '',
      is_layout: true,
      status: 1
    }
  },
  templateTypes () {
    return [{
      name: 'Html',
      id: 'html'
    }, {
      name: 'Tekstowy',
      id: 'text'
    }]
  }

}



// WEBPACK FOOTER //
// ./src/services/Templates.js